import axios from 'axios';
import axiosInstance, { getStoredToken } from '@core/api/axios-config';
import {
    CategoryDto,
    CreateCategoryDto,
    UpdateCategoryDto,
    CategoryPagedResult,
    CategoryFilterParams
} from '../types/category.types';

/**
 * Categories API Service
 * Replicated from Angular CategoryService
 */
export const categoriesApi = {
    /**
     * Get all categories (unpaginated)
     */
    getAll: async (): Promise<CategoryDto[]> => {
        const response = await axiosInstance.get<CategoryDto[]>('/categories');
        return response.data;
    },

    /**
     * Get paginated categories with search
     */
    getPaged: async (params: CategoryFilterParams): Promise<CategoryPagedResult> => {
        const queryParams = new URLSearchParams();
        queryParams.set('page', params.page.toString());
        queryParams.set('pageSize', params.pageSize.toString());
        if (params.search) {
            queryParams.set('search', params.search);
        }

        const response = await axiosInstance.get<CategoryPagedResult>('/categories/paged', {
            params: queryParams
        });
        return response.data;
    },

    /**
     * Get category by ID
     */
    getById: async (id: string): Promise<CategoryDto> => {
        const response = await axiosInstance.get<CategoryDto>(`/categories/${id}`);
        return response.data;
    },

    /**
     * Create new category
     */
    create: async (data: CreateCategoryDto): Promise<CategoryDto> => {
        const response = await axiosInstance.post<CategoryDto>('/categories', data);
        return response.data;
    },

    /**
     * Update existing category
     */
    update: async (id: string, data: UpdateCategoryDto): Promise<CategoryDto> => {
        const response = await axiosInstance.put<CategoryDto>(`/categories/${id}`, data);
        return response.data;
    },

    /**
     * Delete category
     */
    delete: async (id: string): Promise<void> => {
        await axiosInstance.delete(`/categories/${id}`);
    },

    /**
     * Upload category image
     */
    uploadImage: async (file: File): Promise<{ imageUrl: string }> => {
        const formData = new FormData();
        formData.append('file', file);

        const token = getStoredToken();
        const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api';

        const response = await axios.post<{ imageUrl: string }>(`${baseURL}/fileupload/category`, formData, {
            headers: {
                ...(token ? { Authorization: `Bearer ${token}` } : {})
            }
        });
        return response.data;
    }
};
